import $ from 'jquery';
import ko from 'knockout';
import { DateTime } from 'luxon';
import moment from 'moment';
import Mousetrap from 'mousetrap';

import Ajv from './lib/external/ajv';
import AjvKeywords from './lib/external/ajv-keywords';

import './builtins/shim';

const _window = window as any; // eslint-disable-line typescript/no-explicit-any

_window.jQuery = $;
_window.$ = $;
_window.moment = moment;
_window.ko = ko;
_window.Mousetrap = Mousetrap;
_window.Ajv = Ajv;
_window.AjvKeywords = AjvKeywords;
_window.DateTime = DateTime;
